var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMuteIconMobileinline = function SvgMuteIconMobileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.133 29.567-4.4-4.4q-.933.666-2.016 1.15-1.084.483-2.25.75V25a19 19 0 0 0 1.483-.517 6 6 0 0 0 1.35-.75L16.8 18.2v7.9l-6.667-6.667H4.8v-8H10L2.667 4.1 4.1 2.667 29.567 28.1zm-1.2-7.734L25.5 20.4a9 9 0 0 0 .983-2.4 10.7 10.7 0 0 0 .317-2.6q0-3.434-2-6.15T19.467 5.8V3.733q4.133.934 6.733 4.184t2.6 7.483q0 1.7-.467 3.333a11.8 11.8 0 0 1-1.4 3.1m-4.466-4.466-3-3v-4.334a5.54 5.54 0 0 1 2.45 2.2 6.1 6.1 0 0 1 .883 3.2 5.8 5.8 0 0 1-.333 1.934M16.8 11.7l-3.467-3.467L16.8 4.767zm-2 9.533v-5l-2.8-2.8H6.8v4H11z"
  })));
};
export default SvgMuteIconMobileinline;